<section class="admin-project-form">
  <h2>{{ isEditMode ? 'Edit project' : 'Create project' }}</h2>

  <form class="project-form" [formGroup]="projectForm" (ngSubmit)="submit()">
    <mat-form-field appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status">
        @for (status of statusOptions; track status) {
          <mat-option [value]="status">{{ status }}</mat-option>
        }
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Visibility</mat-label>
      <mat-select formControlName="visibility">
        @for (v of visibilityOptions; track v) {
          <mat-option [value]="v">{{ visibilityLabel(v) }}</mat-option>
        }
      </mat-select>
      <mat-hint>Hidden: any signed-in viewer. Personal: admin only (not listed for visitors).</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Short description</mat-label>
      <textarea matInput formControlName="short_description" rows="3"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Long description</mat-label>
      <textarea matInput formControlName="long_description" rows="5"></textarea>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Cover image URL</mat-label>
      <input matInput formControlName="imageUrl" />
    </mat-form-field>

    <app-imagebucket-picker
      [coverUrl]="projectForm.get('imageUrl')?.value ?? ''"
      [galleryUrls]="imagebucketGalleryLines()"
      (pick)="onImagebucketPick($event)"
    />

    <mat-form-field appearance="outline">
      <mat-label>Gallery image URLs</mat-label>
      <textarea matInput formControlName="imageUrlsText" rows="4" placeholder="One URL per line"></textarea>
      <mat-hint>One URL per line (e.g. hosted assets or external URLs). Detail page shows all in a carousel; portfolio cards use the cover image, or the first line here if cover is empty.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Start date</mat-label>
      <input matInput type="text" formControlName="startDate" placeholder="e.g. 2024-03-15" autocomplete="off" />
      <mat-hint>Optional. YYYY-MM-DD recommended.</mat-hint>
      @if (projectForm.get('startDate')?.hasError('dateParse')) {
        <mat-error>Could not parse that date. Use YYYY-MM-DD or a clear date string.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>End date</mat-label>
      <input matInput type="text" formControlName="endDate" placeholder="e.g. 2024-12-01" autocomplete="off" />
      <mat-hint>Optional. YYYY-MM-DD recommended.</mat-hint>
      @if (projectForm.get('endDate')?.hasError('dateParse')) {
        <mat-error>Could not parse that date. Use YYYY-MM-DD or a clear date string.</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Categories</mat-label>
      <mat-select formControlName="categories" multiple>
        @for (c of categoryOptions; track c) {
          <mat-option [value]="c">{{ c }}</mat-option>
        }
      </mat-select>
      <mat-hint>Predefined list; extend in src/app/constants/project-categories.ts.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Tags — pick existing</mat-label>
      <mat-select formControlName="tagsFromExisting" multiple>
        @for (t of existingTagOptions; track t) {
          <mat-option [value]="t">{{ t }}</mat-option>
        }
      </mat-select>
      <mat-hint>Tags used on any project; combine with additional tags below.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Tags — additional (comma separated)</mat-label>
      <input matInput formControlName="tagsExtra" autocomplete="off" />
    </mat-form-field>

    <div class="form-actions">
      <button mat-flat-button color="primary" type="submit">Save</button>
      <a mat-button routerLink="/admin/projects">Cancel</a>
    </div>
  </form>
</section>
